import React from 'react';
import { hidePopup } from '../../helpers/uiFunctions/uiActions';
import { InputRow } from '../../helpers/uiComponents/InputRow';

function isActive(startDate, endDate, filter) {
	if (startDate) {
		var dateObj = new Date();

		var month = dateObj.getUTCMonth() + 1; month = month < 10 ? '0' + month : '' + month;
		var day = dateObj.getUTCDate(); day = day < 10 ? '0' + day : '' + day;
		var year = dateObj.getUTCFullYear();
		var now = year+"-"+month+"-"+day;

		var status = "up";
		
		if (endDate) {
			// promo
			if (now < startDate && now < endDate) {
				status = "paused";
			} else if (now > startDate && now > endDate) {
				status = "down";
			}
		} else {
			// blog
			if (now < startDate) {
				status = "down";
			} else if (now > startDate) {
				status = "up";
			}
		}

	} else {
		status = "noDate";
	}
	
	return status;
}


export class CheckClientPromos extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			promoReport: null,
		}
	}

	render() {
		
		let reportData = this.props.report.result;
		let reportSuccess; reportSuccess = this.props.report.success;
		let clients = this.props.clients;

		return (
			<div id="check-client-form">
				<i className="fas fa-times icon" onClick={() => hidePopup("check-client-form")}></i>
				<InputRow
					label="Choose a Client" type="select" property="clients"
					onChange={(e) => this.props.getReport(e.target.value)}
					description={"Choose a client to check their current and future promotions. Promotions that have ended are not listed"}
					options={clients}
				/>
				<h3>Promotions</h3>
				{(reportSuccess) && (
					<div>
						{reportData.map(promo => (
							<div className={"promo-summary "+isActive(promo.startDate, promo.endDate)}>
								<div className="promo-name">
									<h4><span className={"status "+isActive(promo.startDate, promo.endDate)}></span> {promo.name}</h4>
									<span className="date">Start Date: {promo.startDate}</span><span className="date">End Date: {promo.endDate}</span>
								</div>
								<div>Priority: {promo.priority}</div>
								<div>Form Name: {promo.formName}</div>
								<div>Brand Specific: {promo.brandList}</div>

								<h4>Widgets</h4>
								<div className="widget-summary">
									{promo.widgets.map(widget => (
										<div className="widget">
											<div><strong>{widget.type}</strong>: {widget.name}</div>
											{(widget.type === "slide") && (
												<div>
													<div>Order: {widget.order}</div>
													<div>Link: {widget.link}</div>
												</div>
											)}
											{(widget.type === "banner") && (
												<div>
													<div>Link: {widget.link}</div>
												</div>
											)}
										</div>
									))}
								</div>
							</div>
						))}
					</div>
				)}
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/component_promotions/Explorer/CheckClientPromos.js